<style scoped>
.form {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(50px);
  border-radius: 20px;
}
</style>

<template>
  <div>
    <transition name="show-fade" mode="out-in">
      <component 
        :is="forms[formName]"
        class="form"
        />
    </transition>
  </div>
</template>

<script>
import Main from "./forms/Main.vue";
import Passport from "./forms/Passport.vue";
import Additional from "./forms/Additional.vue";
import Approved from "./forms/Approved.vue";

export default {
  props: {
    value: String,
  },
  computed: {
    formName() {
      return this.value;
    },
  },
  watch: {
		formName(name) {
      setTimeout(() => {
        top.postMessage({
            event_id: 'scrollFrameTo',
            position: 'start',
        },'*');

      }, 500);
      
      // this.$connector.state();
    },
  },
  data: () => ({
    forms: {
      Main,
      Passport,
      Additional,
      Approved
    },
    baseSize: {
      Main: 1000,
      // Rates: 900,
      // Questionnaire: 650,
      // AdditionalServices: 850,
      // Sms: 850,
      // StatusWaiting: 600,
      // SelectedAccessApplication: 800,
      // Accept: 500,
      // Decline: 500,     
    }
  })
}
</script>